import type { RouteRecordRaw } from 'vue-router';
import { requireScope, requireAssessing, requireNotAssessing } from './guards/assessment';

export default [
  {
    path: 'assessment',
    children: [
      {
        path: 'scope',
        name: 'scoping',
        component: () => import('@/modules/assessment/ScopingQuestions.vue'),
      },
      {
        path: 'wizard/:tab?',
        name: 'wizard',
        component: () => import('@/modules/assessment/WizardComponentSelector.vue'),
        beforeEnter: [requireScope, requireAssessing],
        props: true,
      },
      {
        path: ':tab?',
        name: 'assessment',
        component: () => import('@/modules/assessment/AssessmentOverviewPage.vue'),
        beforeEnter: [requireScope, requireNotAssessing],
        props: true,
      },
    ],
  },
] satisfies RouteRecordRaw[];
